import moment from 'moment';
import { formatCpfCnpj, dateMaskToMomentMask, formatValue, formatDateTime } from '../../util';
import { Form } from 'react-bootstrap';

export const DynamicColumn = ({ gridColumns, data }) => {
  const format = 'DD/MM/YYYY';

  return (
    <>
      {gridColumns?.map((column, idx) => {
        const value = data[column.id];
        const type = column.type;
        const mask = column.mask;

        switch (type) {
          case 'data':
            return (
              <td style={{ padding: 6 }} key={idx} id={idx}>
                {value == null
                  ? '-'
                  : moment(value).format(mask ? dateMaskToMomentMask(mask) : format)}
              </td>
            );

          case 'hora':
            return (
              <td style={{ padding: 6 }} key={idx} id={idx}>
                {value == null ? '-' : moment(value, 'HH:mm:ss').format('HH:mm')}
              </td>
            );

          case 'datetime':
            return (
              <td style={{ padding: 6 }} key={idx} id={idx}>
                {value == null ? '-' : formatDateTime(value)}
              </td>
            );

          case 'valor':
            return (
              <td
                style={{
                  padding: 6,
                  textAlign: 'right',
                }}
                key={idx}
                id={idx}
              >
                {value == null ? '-' : formatValue(value, mask)}
              </td>
            );

          case 'cpfcnpj':
            return (
              <td style={{ padding: 6 }} key={idx} id={idx}>
                {value == null ? '-' : formatCpfCnpj(value)}
              </td>
            );

          case 'boolean':
            return (
              <td style={{ padding: 1 }} id={idx}>
                <Form.Check
                  disabled
                  type="switch"
                  checked={value}
                  style={{ marginLeft: 20, position: 'relative' }}
                />
              </td>
            );

          default:
            return (
              <td
                style={{
                  padding: 6,
                  textAlign: type === 'inteiro' ? 'right' : 'left',
                }}
                id={idx}
                key={idx}
              >
                {value == null ? '-' : value}
              </td>
            );
        }
      })}
    </>
  );
};
